import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { loadListCameraFailed, loadListCameraSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';

export default function* loadListCamera(action) {
  try {
    const url = `${BACKEND_URL}/host-problems/short-list`;
    const pool = {
      filter: {
        type: 2,
      },
    };
    const userDataResponse = yield makeRequest(url, pool, action, 'POST');
    const responseJson = yield userDataResponse.json();
    if (userDataResponse && userDataResponse.status === OK) {
      yield put(loadListCameraSuccessful(responseJson));
      yield call(resolveActionPromise(action, responseJson));
    } else {
      yield put(loadListCameraFailed(responseJson));
      yield call(rejectActionPromise(action, responseJson));
    }
  } catch (e) {
    yield put(loadListCameraFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
